import { boot } from './boot.jsx';

boot(document.getElementById('app'));
